let keys = "";
if (
  window.location.hostname === "localhost" ||
  window.location.hostname === "127.0.0.1" ||
  window.location.hostname === ""
) {
  keys = "http://localhost:3002";
} else if (window.location.hostname === "pay.goola.run") {
  keys = "https://gapi.goola.run";
} else if (window.location.hostname === "pay.stage.goola.run") {
  // KAN-1214: Sandbox stage env. The previous stage mapping
  // (d18psq8exj9g9a.cloudfront.net -> staging.gapi.goola.run) pointed the
  // PROD distribution's raw hostname at the retired old-stage API.
  keys = "https://gapi.stage.goola.run";
}

export default keys;
